window.addEventListener('load', function() {
	var forms = document.querySelectorAll('form:not([novalidate])');

	// For now we don't validate, so add the novalidate attribute and return
	// Once we will enable client-side validation, we must remove this
	Array.prototype.forEach.call(forms, function(form) {
		form.setAttribute('novalidate', undefined);
	});
	return;

	if (forms.length === 0) {
		return;
	}

	// Run over all forms that need validation
	Array.prototype.forEach.call(forms, function(form) {
		// Add the novalidate attribute, as we will do it ourself
		form.setAttribute('novalidate', true);

		form.addEventListener('submit', function(e) {
			e.preventDefault();

			// Check inputs with validation
			var inputs = form.querySelectorAll('input:invalid');

			if (inputs.length === 0) {
				// No validation error were found, so we can submit
				return form.submit();
			}

			// First hide all error messages
			var errorMessages = form.querySelectorAll('.error-message-visible');
			Array.prototype.forEach.call(errorMessages, function(errorMessage) {
				errorMessage.classList.remove('error-message-visible');
				var input = form.querySelector('[data-error-message=' + errorMessage.id + ']');
				input.classList.remove('with-visible-error-message');
			});

			// Show the error messages for invalid inputs
			Array.prototype.forEach.call(inputs, function(input) {
				var errorMessageId = input.getAttribute('data-error-message');
				if (!errorMessageId) {
					return;
				}
				input.classList.add('with-visible-error-message');
				var errorMessage = document.getElementById(errorMessageId);
				errorMessage.classList.add('error-message-visible');
			});

		});
	});
});
